export default __webpack_public_path__ + "static/media/thumb-GNSS-Antenna-5.510df721.png";